import { useEffect, useState } from "react";
import { formatDatePerType, parseJsonSafe, validateArray } from "../../utils/validate";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import { Anchor, H3, Label } from "../Text";
import { MessageOnLabel } from "../Forms/FormMessages";
import Select from "react-select";
import { Button } from "../Buttons";
import TableComplete from "../Tables/TableComplete";
import { Tooltip } from "react-tippy";
import { Request } from "../../hooks/Request";
import FormAddSubDataDynamic from "../../containers/subDataDocForms/FormAddSubDataDynamic";
import { requestAuth } from "../services/RequestService";
import { toast } from "react-toastify";

const InputSubDataDocsAdd = ({ field }) => {
  const permissionField = parseJsonSafe(field?.permission);
  const [selectValue, setSelectValue] = useState('')
  const [subDatas, setSubDatas] = useState([])
  const { data: fieldOpts } = Request({
    urlApi: `dropdown/${field.url}/options`
  });

  const { data: subDataList, call, loading } = Request({
    urlApi: `/dataSet/procedure/${field.id}/${field.fieldId ? 'field' : 'fieldname'}/${field.fieldId ?? field.fieldname}/subdata`
  });

  const { openDialog, dialogClose } = useDialog()
  function generateFormAdd(data, onClose, reload, urlApi, initVals) {
    const commonProps = {
      data,
      onClose,
      allowEmpty: true,
      // addFieldsForm: validateArray(permissionField?.fields) ? permissionField?.fields?.filter(x => x.formConfig === true) : [],
      reload,
      urlApi,
      formFields: validateArray(permissionField?.fields) ? permissionField?.fields?.filter(x => x.formConfig === true) : [],
      initVals,
      refFileIndex: 'descriptionRef'
    };

    if (selectValue) {
      return (
        <FormAddSubDataDynamic
          {...commonProps}
          addTitle={selectValue}
          reload={() => {
            reload();
            setSelectValue('');
          }}
          field={{ ...field, label: selectValue }}
        />
      );
    } else {
      return <FormAddSubDataDynamic {...commonProps} addTitle={'Editar documento'} />;
    }
  }

  function handleUpdateForm(data) {
    const parsedDetails = data.details ? JSON.parse(data.details) : [];
    let numVal = data.numberValue;
    let numberValue = numVal !== null && numVal !== undefined && numVal !== '' && !isNaN(Number(numVal)) ? Number(numVal) : 0;
    if (numberValue === 0) {
      numberValue = fieldOpts?.find(x => x.name === data.label)?.data;
    }
    const formattedData = {
      ...data,
      ...parsedDetails
    };
    openDialog(generateFormAdd(formattedData, dialogClose, call, `dataset/procedure/subData/${data.id}`, { ...data, numberValue: numberValue ?? data.numberValue, endDate: data.endDate ? formatDatePerType(new Date(data.endDate), 'input') : '', 'descriptionRef': data.description }));
  }

  const HandleCreateForm = () => {
    let numVal = fieldOpts?.find(x => x.name === selectValue)?.data;
    const numberValue = numVal !== null && numVal !== undefined && numVal !== '' && !isNaN(Number(numVal)) ? Number(numVal) : 0;
    if (selectValue !== "") {
      openDialog(generateFormAdd({ label: selectValue }, dialogClose, call, `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`, { label: selectValue, numberValue: numberValue }));
    }
  };

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el archivo?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`dataset/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  async function handleUpdateCheck(e, dataItem) {
    let parsedDetails = dataItem.details ? JSON.parse(dataItem.details) : [];
    parsedDetails = { ...parsedDetails, [e.target.name]: e.target.checked }
    // Object.keys(dataItem)
    //   .filter((key) => key.startsWith("det_"))
    //   .forEach((key) => {
    //     details[key] = dataItem[key];
    //   });

    await requestAuth("put", `dataset/procedure/subData/${dataItem.id}`, { ...dataItem, details: JSON.stringify(parsedDetails) })
      .then(() => {
        toast.success('Se guardaron los cambios')
        call()
      })
      .catch(() => {
        toast.error('Error al guardar los cambios')
      });
  }

  const options = fieldOpts?.map((opt) => ({
    value: opt.name,
    label: opt.name,
  }));

  useEffect(() => {
    setSubDatas(subDataList?.map(datai => {
      const parsedDetails = datai.details
        ? (typeof datai.details === 'string' ? JSON.parse(datai.details) : datai.details)
        : [];

      return {
        ...datai,
        ...parsedDetails
      };
    }))
  }, [subDataList])

  return (
    <div className="flex flex-col gap-2">
      <Label className="my-[20px]" htmlFor={field.name}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      {
        permissionField?.buttons?.includes("create") &&
        <div>
          <Select
            name="FieldId"
            value={options?.find((opt) => opt.value === selectValue) || null}
            onChange={(selectedOption) => setSelectValue(selectedOption?.value || '')}
            options={options ?? []}
            placeholder="Seleccionar tipo de documento"
            isClearable
          />

          {
            selectValue !== "" &&
            <Button
              onClick={() => HandleCreateForm()}
              // onClick={() => handleForm(values.field, values.isNew)}
              className="py-2 mt-1 w-full"
            >
              Adicionar documento
            </Button>
          }
        </div>
      }
      <div className="overflow-auto flex flex-col gap-3">
        {subDatas && subDatas?.length > 0 && (
          <div className="bg-stone-400/20 shadow-sm shadow-stone-400 p-2 rounded-md">
            <TableComplete
              header={[
                ...(
                  validateArray(permissionField?.fields) ?
                    permissionField?.fields?.filter(x => x.tableConfig === true)?.map((tableItem) => (

                      tableItem.type === "custom" ?
                        {
                          name: "url",
                          label: "Enlace",
                          type: "custom",
                          builder: (item) => {
                            if (item) {
                              return (
                                <Anchor
                                  href={item}
                                  className="text-[#1d4ed8] underline"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Abrir
                                </Anchor>
                              );
                            } else {
                              return "-";
                            }
                          },
                        }
                        :
                        tableItem.typeInput === "checkButton" ?
                          {
                            name: tableItem.name,
                            label: tableItem.label,
                            type: "custom",
                            builder: (item, _, headData) => {
                              return (
                                <div className="flex justify-center">
                                  <input
                                    type="checkbox"
                                    name={tableItem.name}
                                    defaultChecked={
                                      headData.details &&
                                      JSON.parse(headData.details)?.[tableItem.name] === true
                                    }
                                    className="cursor-pointer"
                                    onChange={(e) => handleUpdateCheck(e, headData)}
                                  />
                                </div>
                              );
                            },
                          }
                          :
                          tableItem
                    ))
                    :
                    []
                ),
                {
                  name: "add",
                  type: "action",
                  label: "",
                  sticky: true,
                  actions: [
                    ...(
                      permissionField?.openUrl ?
                        [
                          {
                            icon: "fas fa-trash",
                            builder: (item) => {
                              if (item) {
                                return (
                                  <Tooltip
                                    // title={act.validate ? (item.showButtonJoinPdfs ? item.showButtonJoinPdfs : act.label) : act.label}
                                    title={'Abrir'}
                                    position="right"
                                    trigger="mouseenter"
                                  >
                                    <Anchor
                                      href={item[permissionField?.openUrl] !== null && item[permissionField?.openUrl] !== '' ? item[permissionField?.openUrl] : null}
                                      className={`${item[permissionField?.openUrl] !== null && item[permissionField?.openUrl] !== '' ? 'text-[#1d4ed8]' : 'text-gray-400'} text-lg`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="far fa-file-pdf" />
                                    </Anchor>
                                  </Tooltip>
                                );
                              } else {
                                return "-";
                              }
                            },
                          }
                        ] :
                        []
                    ),
                    ...(
                      permissionField?.buttons?.includes("edit") ?
                        [{
                          label: "Editar",
                          icon: "fas fa-edit",
                          action: handleUpdateForm,
                          color: "text-[#1d4ed8]",
                        }]
                        :
                        []
                    ),
                    ...(
                      permissionField?.buttons?.includes("delete") ?
                        [{
                          label: "Eliminar",
                          icon: "fas fa-trash",
                          action: handleDelete,
                          color: "text-red-500",
                        }]
                        :
                        []),
                  ],
                },
              ]}
              data={
                subDatas
              }
            />
          </div>
        )
        }
        {(loading && subDatas?.length === 0) &&
          <div className="flex flex-col justify-center py-3 italic gap-2 bg-gray-400/20 rounded-md">
            <H3 className="text-gray-500 text-center text-sm">No hay documentos asociados</H3>
            <i className="far fa-file-lines text-[40px] text-gray-400" />
          </div>
        }
      </div>
    </div>
  );
};

export default InputSubDataDocsAdd;